import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  // Handle body scroll and Escape key
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setActiveModal(null);
    };
    if (activeModal) {
      document.body.style.overflow = 'hidden';
      window.addEventListener('keydown', handleEsc);
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
      window.removeEventListener('keydown', handleEsc);
    };
  }, [activeModal]);
  const renderContent = () => {
    if (activeModal === 'privacy') {
      return <div className="space-y-6 text-brand-gray" data-id="element-21">
          <h2 className="text-2xl md:text-3xl font-bold text-brand-white mb-8" data-id="element-22">
            Política de Privacidad
          </h2>

          <section data-id="element-23">
            <h3 className="text-lg font-semibold text-brand-gold mb-3" data-id="element-24">
              1. Recopilación de Datos
            </h3>
            <p className="leading-relaxed" data-id="element-25">
              Recopilamos información personal que usted nos proporciona
              voluntariamente al registrarse, expresar interés en obtener
              información sobre nosotros o nuestros productos y servicios. La
              información personal recopilada depende del contexto de sus
              interacciones con nosotros y las elecciones que realice.
            </p>
          </section>

          <section data-id="element-26">
            <h3 className="text-lg font-semibold text-brand-gold mb-3" data-id="element-27">
              2. Uso de la Información
            </h3>
            <p className="leading-relaxed" data-id="element-28">
              Utilizamos la información personal recopilada a través de nuestro
              sitio web para una variedad de fines comerciales descritos a
              continuación. Procesamos su información personal para estos fines
              en base a nuestros intereses comerciales legítimos, para celebrar
              o ejecutar un contrato con usted, con su consentimiento y/o para
              el cumplimiento de nuestras obligaciones legales.
            </p>
          </section>

          <section data-id="element-29">
            <h3 className="text-lg font-semibold text-brand-gold mb-3" data-id="element-30">
              3. Cookies y Tecnologías de Seguimiento
            </h3>
            <p className="leading-relaxed" data-id="element-31">
              Podemos utilizar cookies y tecnologías de seguimiento similares
              (como balizas web y píxeles) para acceder o almacenar información.
              Puede configurar su navegador para que rechace todas o algunas de
              las cookies del navegador, o para que le avise cuando los sitios
              web configuren o accedan a las cookies.
            </p>
          </section>

          <section data-id="element-32">
            <h3 className="text-lg font-semibold text-brand-gold mb-3" data-id="element-33">
              4. Derechos del Usuario
            </h3>
            <p className="leading-relaxed" data-id="element-34">
              Dependiendo de su ubicación, puede tener ciertos derechos con
              respecto a su información personal, como el derecho a solicitar
              acceso y obtener una copia de su información personal, solicitar
              rectificación o eliminación, y restringir el procesamiento de su
              información personal.
            </p>
          </section>

          <section data-id="element-35">
            <h3 className="text-lg font-semibold text-brand-gold mb-3" data-id="element-36">
              5. Modificaciones a esta Política
            </h3>
            <p className="leading-relaxed" data-id="element-37">
              Podemos actualizar esta política de privacidad de vez en cuando.
              La versión actualizada se indicará mediante una fecha de
              "Revisión" actualizada y la versión actualizada entrará en
              vigencia tan pronto como sea accesible. Le recomendamos que revise
              esta política de privacidad con frecuencia.
            </p>
          </section>
        </div>;
    }
    if (activeModal === 'terms') {
      return <div className="space-y-6 text-brand-gray" data-id="element-38">
          <h2 className="text-2xl md:text-3xl font-bold text-brand-white mb-8" data-id="element-39">
            Términos y Condiciones
          </h2>

          <section data-id="element-40">
            <h3 className="text-lg font-semibold text-brand-gold mb-3" data-id="element-41">
              1. Aceptación de los Términos
            </h3>
            <p className="leading-relaxed" data-id="element-42">
              Al acceder y utilizar este sitio web, usted acepta estar sujeto a
              estos Términos y Condiciones y a todas las leyes y regulaciones
              aplicables. Si no está de acuerdo con alguno de estos términos,
              tiene prohibido usar o acceder a este sitio.
            </p>
          </section>

          <section data-id="element-43">
            <h3 className="text-lg font-semibold text-brand-gold mb-3" data-id="element-44">
              2. Descripción del Servicio
            </h3>
            <p className="leading-relaxed" data-id="element-45">
              Proporcionamos recursos digitales, guías y materiales educativos.
              Nos reservamos el derecho de retirar o modificar nuestro servicio,
              y cualquier material que proporcionemos, a nuestra entera
              discreción y sin previo aviso. No seremos responsables si, por
              cualquier motivo, todo o parte del sitio web no está disponible en
              cualquier momento o durante cualquier período.
            </p>
          </section>

          <section data-id="element-46">
            <h3 className="text-lg font-semibold text-brand-gold mb-3" data-id="element-47">
              3. Obligaciones del Usuario
            </h3>
            <p className="leading-relaxed" data-id="element-48">
              Usted acepta utilizar el sitio web solo para fines lícitos y de
              una manera que no infrinja los derechos de, restrinja o inhiba el
              uso y disfrute del sitio web por parte de cualquier tercero. El
              comportamiento prohibido incluye acosar o causar angustia o
              inconvenientes a cualquier otra persona, transmitir contenido
              obsceno u ofensivo.
            </p>
          </section>

          <section data-id="element-49">
            <h3 className="text-lg font-semibold text-brand-gold mb-3" data-id="element-50">
              4. Propiedad Intelectual
            </h3>
            <p className="leading-relaxed" data-id="element-51">
              El sitio web y todo su contenido original, características y
              funcionalidad son propiedad nuestra y están protegidos por
              derechos de autor, marcas comerciales, patentes, secretos
              comerciales y otras leyes de propiedad intelectual o derechos de
              propiedad. No se le transfiere ningún derecho, título o interés en
              el sitio web o en cualquier contenido del sitio web.
            </p>
          </section>

          <section data-id="element-52">
            <h3 className="text-lg font-semibold text-brand-gold mb-3" data-id="element-53">
              5. Limitación de Responsabilidad
            </h3>
            <p className="leading-relaxed" data-id="element-54">
              En ningún caso seremos responsables de ningún daño directo,
              indirecto, especial, incidental, consecuente o punitivo que surja
              de o esté relacionado con su uso, o incapacidad de uso, del sitio
              web o cualquier contenido del sitio web, ya sea basado en
              garantía, contrato, agravio (incluyendo negligencia) o cualquier
              otra teoría legal.
            </p>
          </section>
        </div>;
    }
    return null;
  };
  return <>
      <footer className="py-10 border-t border-white/5 text-center text-brand-gray text-sm relative z-10 bg-brand-black" data-id="element-55">
        <div className="max-w-4xl mx-auto px-4 flex flex-col items-center gap-6" data-id="element-56">
          <div className="flex flex-wrap justify-center items-center gap-6 md:gap-10" data-id="element-57">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-brand-gold transition-colors duration-300" data-id="element-58">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="hover:text-brand-gold transition-colors duration-300" data-id="element-59">
              Términos y Condiciones
            </button>
          </div>
          <p className="opacity-60" data-id="element-60">
            © {new Date().getFullYear()} CeroRastro™. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-61">
        {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 md:p-12" data-id="element-62">
            {/* Backdrop */}
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setActiveModal(null)} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-63" />

            {/* Modal Content */}
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative w-full max-w-3xl max-h-[85vh] bg-brand-black border border-brand-gold/20 rounded-2xl shadow-[0_0_50px_rgba(201,168,76,0.15)] overflow-hidden flex flex-col" data-id="element-64">
              {/* Header / Close Button */}
              <div className="flex justify-end p-4 border-b border-white/5 bg-brand-black/50 backdrop-blur-md sticky top-0 z-10" data-id="element-65">
                <button onClick={() => setActiveModal(null)} className="text-brand-gray hover:text-brand-white transition-colors p-2 rounded-lg hover:bg-white/5" aria-label="Cerrar modal" data-id="element-66">
                  <X className="w-6 h-6" data-id="element-67" />
                </button>
              </div>

              {/* Scrollable Content Area */}
              <div className="p-6 sm:p-8 md:p-10 overflow-y-auto custom-scrollbar" data-id="element-68">
                {renderContent()}
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>
    </>;
}